import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoPageLayout } from '@/components/layout/SeoPageLayout';
import { Link } from '@/components/links';
import { FAQs, Hint, Image, Paragraph, Regular, SemiBold, SubHeader, Table, UnorderedList } from '@/components/seo';
import { LINKS } from '@/constants/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { NumericRange } from '@/types/range';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(595);
  const {
    menuPromoBanners
  } = t0;
  usePageView("seo-overdraft");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["seoOverdraft", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = Array.from({
      length: 8
    }, (_, index) => {
      const faqsIndex = index + 1 as NumericRange<1, 8>;
      return {
        question: t(`seoOverdraft:sections.faqs.${faqsIndex}.question`),
        answer: t(`seoOverdraft:sections.faqs.${faqsIndex}.answer`)
      };
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const faqsData = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("seoOverdraft:seo.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("seoOverdraft:seo.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] !== t) {
    t7 = <Trans t={t} i18nKey="seoOverdraft:header.title">{t6}</Trans>;
    t8 = t("seoOverdraft:header.intro");
    $[11] = t;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p>{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("seoOverdraft:header.button");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = LINKS();
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = {
      label: t10,
      to: t11.registration
    };
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("seoOverdraft:sections.1.title");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Paragraph />;
    t15 = <SemiBold />;
    $[23] = t14;
    $[24] = t15;
  } else {
    t14 = $[23];
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      paragraph: t14,
      semibold: t15,
      link1: <Link analyticsParam="linkToLoans" testId="linkToLoans" to={LINKS().loans} />
    };
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t) {
    t17 = <Trans t={t} i18nKey="seoOverdraft:sections.1.content" components={t16} />;
    $[26] = t;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t13 || $[29] !== t17) {
    t18 = {
      title: t13,
      content: t17
    };
    $[28] = t13;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t) {
    t19 = t("seoOverdraft:sections.2.title");
    $[31] = t;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t) {
    t21 = <Trans t={t} i18nKey="seoOverdraft:sections.2.content" components={t20} />;
    $[34] = t;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t) {
    t22 = t("seoOverdraft:sections.2.title");
    $[36] = t;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t22) {
    t23 = <Image src="/images/sections/seoOverdraft/cs/1.png" width={768} height={400} alt={t22} isRounded={true} />;
    $[38] = t22;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== t21 || $[41] !== t23) {
    t24 = <>{t21}{t23}</>;
    $[40] = t21;
    $[41] = t23;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t19 || $[44] !== t24) {
    t25 = {
      title: t19,
      content: t24
    };
    $[43] = t19;
    $[44] = t24;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t) {
    t26 = t("seoOverdraft:sections.3.title");
    $[46] = t;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t) {
    t28 = <Trans t={t} i18nKey="seoOverdraft:sections.3.content" components={t27} />;
    $[49] = t;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== t26 || $[52] !== t28) {
    t29 = {
      title: t26,
      content: t28
    };
    $[51] = t26;
    $[52] = t28;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t) {
    t30 = t("seoOverdraft:sections.4.title");
    $[54] = t;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== t) {
    t32 = <Trans t={t} i18nKey="seoOverdraft:sections.4.content" components={t31} />;
    $[57] = t;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== t30 || $[60] !== t32) {
    t33 = {
      title: t30,
      content: t32
    };
    $[59] = t30;
    $[60] = t32;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== t) {
    t34 = t("seoOverdraft:sections.5.title");
    $[62] = t;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] !== t) {
    t36 = <Trans t={t} i18nKey="seoOverdraft:sections.5.content" components={t35} />;
    $[65] = t;
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] !== t34 || $[68] !== t36) {
    t37 = {
      title: t34,
      content: t36
    };
    $[67] = t34;
    $[68] = t36;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] !== t) {
    t38 = t("seoOverdraft:sections.6.title");
    $[70] = t;
    $[71] = t38;
  } else {
    t38 = $[71];
  }
  let t39;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  let t40;
  if ($[73] !== t) {
    t40 = <Trans t={t} i18nKey="seoOverdraft:sections.6.content" components={t39} />;
    $[73] = t;
    $[74] = t40;
  } else {
    t40 = $[74];
  }
  let t41;
  if ($[75] !== t38 || $[76] !== t40) {
    t41 = {
      title: t38,
      content: t40
    };
    $[75] = t38;
    $[76] = t40;
    $[77] = t41;
  } else {
    t41 = $[77];
  }
  let t42;
  if ($[78] !== t) {
    t42 = t("seoOverdraft:sections.7.title");
    $[78] = t;
    $[79] = t42;
  } else {
    t42 = $[79];
  }
  let t43;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[80] = t43;
  } else {
    t43 = $[80];
  }
  let t44;
  if ($[81] !== t) {
    t44 = <Trans t={t} i18nKey="seoOverdraft:sections.7.content" components={t43} />;
    $[81] = t;
    $[82] = t44;
  } else {
    t44 = $[82];
  }
  let t45;
  if ($[83] !== t42 || $[84] !== t44) {
    t45 = {
      title: t42,
      content: t44
    };
    $[83] = t42;
    $[84] = t44;
    $[85] = t45;
  } else {
    t45 = $[85];
  }
  let t46;
  if ($[86] !== t) {
    t46 = t("seoOverdraft:sections.8.title");
    $[86] = t;
    $[87] = t46;
  } else {
    t46 = $[87];
  }
  let t47;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[88] = t47;
  } else {
    t47 = $[88];
  }
  let t48;
  if ($[89] !== t) {
    t48 = <Trans t={t} i18nKey="seoOverdraft:sections.8.content1" components={t47} />;
    $[89] = t;
    $[90] = t48;
  } else {
    t48 = $[90];
  }
  let t49;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = [...Array(4)];
    $[91] = t49;
  } else {
    t49 = $[91];
  }
  let t50;
  if ($[92] !== t) {
    t50 = <UnorderedList items={t49.map((__0, i) => {
      const transIndex = i + 1 as NumericRange<1, 4>;
      return <Trans key={i} t={t} i18nKey={`seoOverdraft:sections.8.list.${transIndex}`} />;
    })} className="mb-4" />;
    $[92] = t;
    $[93] = t50;
  } else {
    t50 = $[93];
  }
  let t51;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = {
      paragraph: <Paragraph />
    };
    $[94] = t51;
  } else {
    t51 = $[94];
  }
  let t52;
  if ($[95] !== t) {
    t52 = <Trans t={t} i18nKey="seoOverdraft:sections.8.content2" components={t51} />;
    $[95] = t;
    $[96] = t52;
  } else {
    t52 = $[96];
  }
  let t53;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = {
      link1: <Link analyticsParam="linkToAboutDeferredPayment" testId="linkToAboutDeferredPayment" to={LINKS().aboutDeferredPayment} />
    };
    $[97] = t53;
  } else {
    t53 = $[97];
  }
  let t54;
  if ($[98] !== t) {
    t54 = <Hint text={<Trans t={t} i18nKey="seoOverdraft:sections.8.hint" components={t53} />} />;
    $[98] = t;
    $[99] = t54;
  } else {
    t54 = $[99];
  }
  let t55;
  if ($[100] !== t48 || $[101] !== t50 || $[102] !== t52 || $[103] !== t54) {
    t55 = <>{t48}{t50}{t52}{t54}</>;
    $[100] = t48;
    $[101] = t50;
    $[102] = t52;
    $[103] = t54;
    $[104] = t55;
  } else {
    t55 = $[104];
  }
  let t56;
  if ($[105] !== t46 || $[106] !== t55) {
    t56 = {
      title: t46,
      content: t55
    };
    $[105] = t46;
    $[106] = t55;
    $[107] = t56;
  } else {
    t56 = $[107];
  }
  let t57;
  if ($[108] !== t) {
    t57 = t("seoOverdraft:sections.9.title");
    $[108] = t;
    $[109] = t57;
  } else {
    t57 = $[109];
  }
  let t58;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = {
      paragraph: <Paragraph />
    };
    $[110] = t58;
  } else {
    t58 = $[110];
  }
  let t59;
  if ($[111] !== t) {
    t59 = <Trans t={t} i18nKey="seoOverdraft:sections.9.content" components={t58} />;
    $[111] = t;
    $[112] = t59;
  } else {
    t59 = $[112];
  }
  let t60;
  if ($[113] !== t) {
    t60 = t("seoOverdraft:sections.9.table.header.1");
    $[113] = t;
    $[114] = t60;
  } else {
    t60 = $[114];
  }
  let t61;
  if ($[115] !== t60) {
    t61 = <th className="h-32 w-40 rounded-tr-none! text-center!">{t60}</th>;
    $[115] = t60;
    $[116] = t61;
  } else {
    t61 = $[116];
  }
  let t62;
  if ($[117] !== t) {
    t62 = t("seoOverdraft:sections.9.table.header.2");
    $[117] = t;
    $[118] = t62;
  } else {
    t62 = $[118];
  }
  let t63;
  if ($[119] !== t62) {
    t63 = <th className="w-30 text-center!">{t62}</th>;
    $[119] = t62;
    $[120] = t63;
  } else {
    t63 = $[120];
  }
  let t64;
  if ($[121] !== t) {
    t64 = t("seoOverdraft:sections.9.table.header.3");
    $[121] = t;
    $[122] = t64;
  } else {
    t64 = $[122];
  }
  let t65;
  if ($[123] !== t64) {
    t65 = <th className="w-30 text-center!">{t64}</th>;
    $[123] = t64;
    $[124] = t65;
  } else {
    t65 = $[124];
  }
  let t66;
  if ($[125] !== t) {
    t66 = t("seoOverdraft:sections.9.table.header.4");
    $[125] = t;
    $[126] = t66;
  } else {
    t66 = $[126];
  }
  let t67;
  if ($[127] !== t66) {
    t67 = <th className="w-30 text-center!">{t66}</th>;
    $[127] = t66;
    $[128] = t67;
  } else {
    t67 = $[128];
  }
  let t68;
  if ($[129] !== t) {
    t68 = t("seoOverdraft:sections.9.table.header.5");
    $[129] = t;
    $[130] = t68;
  } else {
    t68 = $[130];
  }
  let t69;
  if ($[131] !== t68) {
    t69 = <th className="w-30 text-center!">{t68}</th>;
    $[131] = t68;
    $[132] = t69;
  } else {
    t69 = $[132];
  }
  let t70;
  if ($[133] !== t) {
    t70 = t("seoOverdraft:sections.9.table.header.6");
    $[133] = t;
    $[134] = t70;
  } else {
    t70 = $[134];
  }
  let t71;
  if ($[135] !== t70) {
    t71 = <th className="w-30 rounded-tr-md text-center!">{t70}</th>;
    $[135] = t70;
    $[136] = t71;
  } else {
    t71 = $[136];
  }
  let t72;
  if ($[137] !== t61 || $[138] !== t63 || $[139] !== t65 || $[140] !== t67 || $[141] !== t69 || $[142] !== t71) {
    t72 = <tr>{t61}{t63}{t65}{t67}{t69}{t71}</tr>;
    $[137] = t61;
    $[138] = t63;
    $[139] = t65;
    $[140] = t67;
    $[141] = t69;
    $[142] = t71;
    $[143] = t72;
  } else {
    t72 = $[143];
  }
  let t73;
  if ($[144] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = {
      regular: <Regular />
    };
    $[144] = t73;
  } else {
    t73 = $[144];
  }
  let t74;
  if ($[145] !== t) {
    t74 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.1.columns.1" components={t73} /></td>;
    $[145] = t;
    $[146] = t74;
  } else {
    t74 = $[146];
  }
  let t75;
  if ($[147] !== t) {
    t75 = t("seoOverdraft:sections.9.table.rows.1.columns.2");
    $[147] = t;
    $[148] = t75;
  } else {
    t75 = $[148];
  }
  let t76;
  if ($[149] !== t75) {
    t76 = <td className="w-30">{t75}</td>;
    $[149] = t75;
    $[150] = t76;
  } else {
    t76 = $[150];
  }
  let t77;
  if ($[151] !== t) {
    t77 = t("seoOverdraft:sections.9.table.rows.1.columns.3");
    $[151] = t;
    $[152] = t77;
  } else {
    t77 = $[152];
  }
  let t78;
  if ($[153] !== t77) {
    t78 = <td className="w-30">{t77}</td>;
    $[153] = t77;
    $[154] = t78;
  } else {
    t78 = $[154];
  }
  let t79;
  if ($[155] !== t) {
    t79 = t("seoOverdraft:sections.9.table.rows.1.columns.4");
    $[155] = t;
    $[156] = t79;
  } else {
    t79 = $[156];
  }
  let t80;
  if ($[157] !== t79) {
    t80 = <td className="w-30">{t79}</td>;
    $[157] = t79;
    $[158] = t80;
  } else {
    t80 = $[158];
  }
  let t81;
  if ($[159] !== t) {
    t81 = t("seoOverdraft:sections.9.table.rows.1.columns.5");
    $[159] = t;
    $[160] = t81;
  } else {
    t81 = $[160];
  }
  let t82;
  if ($[161] !== t81) {
    t82 = <td className="w-30">{t81}</td>;
    $[161] = t81;
    $[162] = t82;
  } else {
    t82 = $[162];
  }
  let t83;
  if ($[163] !== t) {
    t83 = t("seoOverdraft:sections.9.table.rows.1.columns.6");
    $[163] = t;
    $[164] = t83;
  } else {
    t83 = $[164];
  }
  let t84;
  if ($[165] !== t83) {
    t84 = <td className="w-30">{t83}</td>;
    $[165] = t83;
    $[166] = t84;
  } else {
    t84 = $[166];
  }
  let t85;
  if ($[167] !== t74 || $[168] !== t76 || $[169] !== t78 || $[170] !== t80 || $[171] !== t82 || $[172] !== t84) {
    t85 = <tr>{t74}{t76}{t78}{t80}{t82}{t84}</tr>;
    $[167] = t74;
    $[168] = t76;
    $[169] = t78;
    $[170] = t80;
    $[171] = t82;
    $[172] = t84;
    $[173] = t85;
  } else {
    t85 = $[173];
  }
  let t86;
  if ($[174] === Symbol.for("react.memo_cache_sentinel")) {
    t86 = {
      regular: <Regular />
    };
    $[174] = t86;
  } else {
    t86 = $[174];
  }
  let t87;
  if ($[175] !== t) {
    t87 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.2.columns.1" components={t86} /></td>;
    $[175] = t;
    $[176] = t87;
  } else {
    t87 = $[176];
  }
  let t88;
  if ($[177] !== t) {
    t88 = t("seoOverdraft:sections.9.table.rows.2.columns.2");
    $[177] = t;
    $[178] = t88;
  } else {
    t88 = $[178];
  }
  let t89;
  if ($[179] !== t88) {
    t89 = <td className="w-30">{t88}</td>;
    $[179] = t88;
    $[180] = t89;
  } else {
    t89 = $[180];
  }
  let t90;
  if ($[181] !== t) {
    t90 = t("seoOverdraft:sections.9.table.rows.2.columns.3");
    $[181] = t;
    $[182] = t90;
  } else {
    t90 = $[182];
  }
  let t91;
  if ($[183] !== t90) {
    t91 = <td className="w-30">{t90}</td>;
    $[183] = t90;
    $[184] = t91;
  } else {
    t91 = $[184];
  }
  let t92;
  if ($[185] !== t) {
    t92 = t("seoOverdraft:sections.9.table.rows.2.columns.4");
    $[185] = t;
    $[186] = t92;
  } else {
    t92 = $[186];
  }
  let t93;
  if ($[187] !== t92) {
    t93 = <td className="w-30">{t92}</td>;
    $[187] = t92;
    $[188] = t93;
  } else {
    t93 = $[188];
  }
  let t94;
  if ($[189] !== t) {
    t94 = t("seoOverdraft:sections.9.table.rows.2.columns.5");
    $[189] = t;
    $[190] = t94;
  } else {
    t94 = $[190];
  }
  let t95;
  if ($[191] !== t94) {
    t95 = <td className="w-30">{t94}</td>;
    $[191] = t94;
    $[192] = t95;
  } else {
    t95 = $[192];
  }
  let t96;
  if ($[193] !== t) {
    t96 = t("seoOverdraft:sections.9.table.rows.2.columns.6");
    $[193] = t;
    $[194] = t96;
  } else {
    t96 = $[194];
  }
  let t97;
  if ($[195] !== t96) {
    t97 = <td className="w-30">{t96}</td>;
    $[195] = t96;
    $[196] = t97;
  } else {
    t97 = $[196];
  }
  let t98;
  if ($[197] !== t87 || $[198] !== t89 || $[199] !== t91 || $[200] !== t93 || $[201] !== t95 || $[202] !== t97) {
    t98 = <tr>{t87}{t89}{t91}{t93}{t95}{t97}</tr>;
    $[197] = t87;
    $[198] = t89;
    $[199] = t91;
    $[200] = t93;
    $[201] = t95;
    $[202] = t97;
    $[203] = t98;
  } else {
    t98 = $[203];
  }
  let t99;
  if ($[204] === Symbol.for("react.memo_cache_sentinel")) {
    t99 = {
      regular: <Regular />
    };
    $[204] = t99;
  } else {
    t99 = $[204];
  }
  let t100;
  if ($[205] !== t) {
    t100 = <td className="h-20 w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.3.columns.1" components={t99} /></td>;
    $[205] = t;
    $[206] = t100;
  } else {
    t100 = $[206];
  }
  let t101;
  if ($[207] !== t) {
    t101 = t("seoOverdraft:sections.9.table.rows.3.columns.2");
    $[207] = t;
    $[208] = t101;
  } else {
    t101 = $[208];
  }
  let t102;
  if ($[209] !== t101) {
    t102 = <td className="w-30">{t101}</td>;
    $[209] = t101;
    $[210] = t102;
  } else {
    t102 = $[210];
  }
  let t103;
  if ($[211] !== t) {
    t103 = t("seoOverdraft:sections.9.table.rows.3.columns.3");
    $[211] = t;
    $[212] = t103;
  } else {
    t103 = $[212];
  }
  let t104;
  if ($[213] !== t103) {
    t104 = <td className="w-30">{t103}</td>;
    $[213] = t103;
    $[214] = t104;
  } else {
    t104 = $[214];
  }
  let t105;
  if ($[215] !== t) {
    t105 = t("seoOverdraft:sections.9.table.rows.3.columns.4");
    $[215] = t;
    $[216] = t105;
  } else {
    t105 = $[216];
  }
  let t106;
  if ($[217] !== t105) {
    t106 = <td className="w-30">{t105}</td>;
    $[217] = t105;
    $[218] = t106;
  } else {
    t106 = $[218];
  }
  let t107;
  if ($[219] !== t) {
    t107 = t("seoOverdraft:sections.9.table.rows.3.columns.5");
    $[219] = t;
    $[220] = t107;
  } else {
    t107 = $[220];
  }
  let t108;
  if ($[221] !== t107) {
    t108 = <td className="w-30">{t107}</td>;
    $[221] = t107;
    $[222] = t108;
  } else {
    t108 = $[222];
  }
  let t109;
  if ($[223] !== t) {
    t109 = t("seoOverdraft:sections.9.table.rows.3.columns.6");
    $[223] = t;
    $[224] = t109;
  } else {
    t109 = $[224];
  }
  let t110;
  if ($[225] !== t109) {
    t110 = <td className="w-30">{t109}</td>;
    $[225] = t109;
    $[226] = t110;
  } else {
    t110 = $[226];
  }
  let t111;
  if ($[227] !== t100 || $[228] !== t102 || $[229] !== t104 || $[230] !== t106 || $[231] !== t108 || $[232] !== t110) {
    t111 = <tr>{t100}{t102}{t104}{t106}{t108}{t110}</tr>;
    $[227] = t100;
    $[228] = t102;
    $[229] = t104;
    $[230] = t106;
    $[231] = t108;
    $[232] = t110;
    $[233] = t111;
  } else {
    t111 = $[233];
  }
  let t112;
  if ($[234] === Symbol.for("react.memo_cache_sentinel")) {
    t112 = {
      regular: <Regular />
    };
    $[234] = t112;
  } else {
    t112 = $[234];
  }
  let t113;
  if ($[235] !== t) {
    t113 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.4.columns.1" components={t112} /></td>;
    $[235] = t;
    $[236] = t113;
  } else {
    t113 = $[236];
  }
  let t114;
  if ($[237] !== t) {
    t114 = t("seoOverdraft:sections.9.table.rows.4.columns.2");
    $[237] = t;
    $[238] = t114;
  } else {
    t114 = $[238];
  }
  let t115;
  if ($[239] !== t114) {
    t115 = <td className="w-30">{t114}</td>;
    $[239] = t114;
    $[240] = t115;
  } else {
    t115 = $[240];
  }
  let t116;
  if ($[241] !== t) {
    t116 = t("seoOverdraft:sections.9.table.rows.4.columns.3");
    $[241] = t;
    $[242] = t116;
  } else {
    t116 = $[242];
  }
  let t117;
  if ($[243] !== t116) {
    t117 = <td className="w-30">{t116}</td>;
    $[243] = t116;
    $[244] = t117;
  } else {
    t117 = $[244];
  }
  let t118;
  if ($[245] !== t) {
    t118 = t("seoOverdraft:sections.9.table.rows.4.columns.4");
    $[245] = t;
    $[246] = t118;
  } else {
    t118 = $[246];
  }
  let t119;
  if ($[247] !== t118) {
    t119 = <td className="w-30">{t118}</td>;
    $[247] = t118;
    $[248] = t119;
  } else {
    t119 = $[248];
  }
  let t120;
  if ($[249] !== t) {
    t120 = t("seoOverdraft:sections.9.table.rows.4.columns.5");
    $[249] = t;
    $[250] = t120;
  } else {
    t120 = $[250];
  }
  let t121;
  if ($[251] !== t120) {
    t121 = <td className="w-30">{t120}</td>;
    $[251] = t120;
    $[252] = t121;
  } else {
    t121 = $[252];
  }
  let t122;
  if ($[253] !== t) {
    t122 = t("seoOverdraft:sections.9.table.rows.4.columns.6");
    $[253] = t;
    $[254] = t122;
  } else {
    t122 = $[254];
  }
  let t123;
  if ($[255] !== t122) {
    t123 = <td className="w-30">{t122}</td>;
    $[255] = t122;
    $[256] = t123;
  } else {
    t123 = $[256];
  }
  let t124;
  if ($[257] !== t113 || $[258] !== t115 || $[259] !== t117 || $[260] !== t119 || $[261] !== t121 || $[262] !== t123) {
    t124 = <tr>{t113}{t115}{t117}{t119}{t121}{t123}</tr>;
    $[257] = t113;
    $[258] = t115;
    $[259] = t117;
    $[260] = t119;
    $[261] = t121;
    $[262] = t123;
    $[263] = t124;
  } else {
    t124 = $[263];
  }
  let t125;
  if ($[264] === Symbol.for("react.memo_cache_sentinel")) {
    t125 = {
      regular: <Regular />
    };
    $[264] = t125;
  } else {
    t125 = $[264];
  }
  let t126;
  if ($[265] !== t) {
    t126 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.5.columns.1" components={t125} /></td>;
    $[265] = t;
    $[266] = t126;
  } else {
    t126 = $[266];
  }
  let t127;
  if ($[267] !== t) {
    t127 = t("seoOverdraft:sections.9.table.rows.5.columns.2");
    $[267] = t;
    $[268] = t127;
  } else {
    t127 = $[268];
  }
  let t128;
  if ($[269] !== t127) {
    t128 = <td className="w-30">{t127}</td>;
    $[269] = t127;
    $[270] = t128;
  } else {
    t128 = $[270];
  }
  let t129;
  if ($[271] !== t) {
    t129 = t("seoOverdraft:sections.9.table.rows.5.columns.3");
    $[271] = t;
    $[272] = t129;
  } else {
    t129 = $[272];
  }
  let t130;
  if ($[273] !== t129) {
    t130 = <td className="w-30">{t129}</td>;
    $[273] = t129;
    $[274] = t130;
  } else {
    t130 = $[274];
  }
  let t131;
  if ($[275] !== t) {
    t131 = t("seoOverdraft:sections.9.table.rows.5.columns.4");
    $[275] = t;
    $[276] = t131;
  } else {
    t131 = $[276];
  }
  let t132;
  if ($[277] !== t131) {
    t132 = <td className="w-30">{t131}</td>;
    $[277] = t131;
    $[278] = t132;
  } else {
    t132 = $[278];
  }
  let t133;
  if ($[279] !== t) {
    t133 = t("seoOverdraft:sections.9.table.rows.5.columns.5");
    $[279] = t;
    $[280] = t133;
  } else {
    t133 = $[280];
  }
  let t134;
  if ($[281] !== t133) {
    t134 = <td className="w-30">{t133}</td>;
    $[281] = t133;
    $[282] = t134;
  } else {
    t134 = $[282];
  }
  let t135;
  if ($[283] !== t) {
    t135 = t("seoOverdraft:sections.9.table.rows.5.columns.6");
    $[283] = t;
    $[284] = t135;
  } else {
    t135 = $[284];
  }
  let t136;
  if ($[285] !== t135) {
    t136 = <td className="w-30">{t135}</td>;
    $[285] = t135;
    $[286] = t136;
  } else {
    t136 = $[286];
  }
  let t137;
  if ($[287] !== t126 || $[288] !== t128 || $[289] !== t130 || $[290] !== t132 || $[291] !== t134 || $[292] !== t136) {
    t137 = <tr>{t126}{t128}{t130}{t132}{t134}{t136}</tr>;
    $[287] = t126;
    $[288] = t128;
    $[289] = t130;
    $[290] = t132;
    $[291] = t134;
    $[292] = t136;
    $[293] = t137;
  } else {
    t137 = $[293];
  }
  let t138;
  if ($[294] === Symbol.for("react.memo_cache_sentinel")) {
    t138 = {
      regular: <Regular />
    };
    $[294] = t138;
  } else {
    t138 = $[294];
  }
  let t139;
  if ($[295] !== t) {
    t139 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.6.columns.1" components={t138} /></td>;
    $[295] = t;
    $[296] = t139;
  } else {
    t139 = $[296];
  }
  let t140;
  if ($[297] !== t) {
    t140 = t("seoOverdraft:sections.9.table.rows.6.columns.2");
    $[297] = t;
    $[298] = t140;
  } else {
    t140 = $[298];
  }
  let t141;
  if ($[299] !== t140) {
    t141 = <td className="w-30">{t140}</td>;
    $[299] = t140;
    $[300] = t141;
  } else {
    t141 = $[300];
  }
  let t142;
  if ($[301] !== t) {
    t142 = t("seoOverdraft:sections.9.table.rows.6.columns.3");
    $[301] = t;
    $[302] = t142;
  } else {
    t142 = $[302];
  }
  let t143;
  if ($[303] !== t142) {
    t143 = <td className="w-30">{t142}</td>;
    $[303] = t142;
    $[304] = t143;
  } else {
    t143 = $[304];
  }
  let t144;
  if ($[305] !== t) {
    t144 = t("seoOverdraft:sections.9.table.rows.6.columns.4");
    $[305] = t;
    $[306] = t144;
  } else {
    t144 = $[306];
  }
  let t145;
  if ($[307] !== t144) {
    t145 = <td className="w-30">{t144}</td>;
    $[307] = t144;
    $[308] = t145;
  } else {
    t145 = $[308];
  }
  let t146;
  if ($[309] !== t) {
    t146 = t("seoOverdraft:sections.9.table.rows.6.columns.5");
    $[309] = t;
    $[310] = t146;
  } else {
    t146 = $[310];
  }
  let t147;
  if ($[311] !== t146) {
    t147 = <td className="w-30">{t146}</td>;
    $[311] = t146;
    $[312] = t147;
  } else {
    t147 = $[312];
  }
  let t148;
  if ($[313] !== t) {
    t148 = t("seoOverdraft:sections.9.table.rows.6.columns.6");
    $[313] = t;
    $[314] = t148;
  } else {
    t148 = $[314];
  }
  let t149;
  if ($[315] !== t148) {
    t149 = <td className="w-30">{t148}</td>;
    $[315] = t148;
    $[316] = t149;
  } else {
    t149 = $[316];
  }
  let t150;
  if ($[317] !== t139 || $[318] !== t141 || $[319] !== t143 || $[320] !== t145 || $[321] !== t147 || $[322] !== t149) {
    t150 = <tr>{t139}{t141}{t143}{t145}{t147}{t149}</tr>;
    $[317] = t139;
    $[318] = t141;
    $[319] = t143;
    $[320] = t145;
    $[321] = t147;
    $[322] = t149;
    $[323] = t150;
  } else {
    t150 = $[323];
  }
  let t151;
  if ($[324] === Symbol.for("react.memo_cache_sentinel")) {
    t151 = {
      regular: <Regular />
    };
    $[324] = t151;
  } else {
    t151 = $[324];
  }
  let t152;
  if ($[325] !== t) {
    t152 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.7.columns.1" components={t151} /></td>;
    $[325] = t;
    $[326] = t152;
  } else {
    t152 = $[326];
  }
  let t153;
  if ($[327] !== t) {
    t153 = t("seoOverdraft:sections.9.table.rows.7.columns.2");
    $[327] = t;
    $[328] = t153;
  } else {
    t153 = $[328];
  }
  let t154;
  if ($[329] !== t153) {
    t154 = <td className="w-30">{t153}</td>;
    $[329] = t153;
    $[330] = t154;
  } else {
    t154 = $[330];
  }
  let t155;
  if ($[331] !== t) {
    t155 = t("seoOverdraft:sections.9.table.rows.7.columns.3");
    $[331] = t;
    $[332] = t155;
  } else {
    t155 = $[332];
  }
  let t156;
  if ($[333] !== t155) {
    t156 = <td className="w-30">{t155}</td>;
    $[333] = t155;
    $[334] = t156;
  } else {
    t156 = $[334];
  }
  let t157;
  if ($[335] !== t) {
    t157 = t("seoOverdraft:sections.9.table.rows.7.columns.4");
    $[335] = t;
    $[336] = t157;
  } else {
    t157 = $[336];
  }
  let t158;
  if ($[337] !== t157) {
    t158 = <td className="w-30">{t157}</td>;
    $[337] = t157;
    $[338] = t158;
  } else {
    t158 = $[338];
  }
  let t159;
  if ($[339] !== t) {
    t159 = t("seoOverdraft:sections.9.table.rows.7.columns.5");
    $[339] = t;
    $[340] = t159;
  } else {
    t159 = $[340];
  }
  let t160;
  if ($[341] !== t159) {
    t160 = <td className="w-30">{t159}</td>;
    $[341] = t159;
    $[342] = t160;
  } else {
    t160 = $[342];
  }
  let t161;
  if ($[343] !== t) {
    t161 = t("seoOverdraft:sections.9.table.rows.7.columns.6");
    $[343] = t;
    $[344] = t161;
  } else {
    t161 = $[344];
  }
  let t162;
  if ($[345] !== t161) {
    t162 = <td className="w-30">{t161}</td>;
    $[345] = t161;
    $[346] = t162;
  } else {
    t162 = $[346];
  }
  let t163;
  if ($[347] !== t152 || $[348] !== t154 || $[349] !== t156 || $[350] !== t158 || $[351] !== t160 || $[352] !== t162) {
    t163 = <tr>{t152}{t154}{t156}{t158}{t160}{t162}</tr>;
    $[347] = t152;
    $[348] = t154;
    $[349] = t156;
    $[350] = t158;
    $[351] = t160;
    $[352] = t162;
    $[353] = t163;
  } else {
    t163 = $[353];
  }
  let t164;
  if ($[354] === Symbol.for("react.memo_cache_sentinel")) {
    t164 = {
      regular: <Regular />
    };
    $[354] = t164;
  } else {
    t164 = $[354];
  }
  let t165;
  if ($[355] !== t) {
    t165 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.8.columns.1" components={t164} /></td>;
    $[355] = t;
    $[356] = t165;
  } else {
    t165 = $[356];
  }
  let t166;
  if ($[357] !== t) {
    t166 = t("seoOverdraft:sections.9.table.rows.8.columns.2");
    $[357] = t;
    $[358] = t166;
  } else {
    t166 = $[358];
  }
  let t167;
  if ($[359] !== t166) {
    t167 = <td className="w-30">{t166}</td>;
    $[359] = t166;
    $[360] = t167;
  } else {
    t167 = $[360];
  }
  let t168;
  if ($[361] !== t) {
    t168 = t("seoOverdraft:sections.9.table.rows.8.columns.3");
    $[361] = t;
    $[362] = t168;
  } else {
    t168 = $[362];
  }
  let t169;
  if ($[363] !== t168) {
    t169 = <td className="w-30">{t168}</td>;
    $[363] = t168;
    $[364] = t169;
  } else {
    t169 = $[364];
  }
  let t170;
  if ($[365] !== t) {
    t170 = t("seoOverdraft:sections.9.table.rows.8.columns.4");
    $[365] = t;
    $[366] = t170;
  } else {
    t170 = $[366];
  }
  let t171;
  if ($[367] !== t170) {
    t171 = <td className="w-30">{t170}</td>;
    $[367] = t170;
    $[368] = t171;
  } else {
    t171 = $[368];
  }
  let t172;
  if ($[369] !== t) {
    t172 = t("seoOverdraft:sections.9.table.rows.8.columns.5");
    $[369] = t;
    $[370] = t172;
  } else {
    t172 = $[370];
  }
  let t173;
  if ($[371] !== t172) {
    t173 = <td className="w-30">{t172}</td>;
    $[371] = t172;
    $[372] = t173;
  } else {
    t173 = $[372];
  }
  let t174;
  if ($[373] !== t) {
    t174 = t("seoOverdraft:sections.9.table.rows.8.columns.6");
    $[373] = t;
    $[374] = t174;
  } else {
    t174 = $[374];
  }
  let t175;
  if ($[375] !== t174) {
    t175 = <td className="w-30">{t174}</td>;
    $[375] = t174;
    $[376] = t175;
  } else {
    t175 = $[376];
  }
  let t176;
  if ($[377] !== t165 || $[378] !== t167 || $[379] !== t169 || $[380] !== t171 || $[381] !== t173 || $[382] !== t175) {
    t176 = <tr>{t165}{t167}{t169}{t171}{t173}{t175}</tr>;
    $[377] = t165;
    $[378] = t167;
    $[379] = t169;
    $[380] = t171;
    $[381] = t173;
    $[382] = t175;
    $[383] = t176;
  } else {
    t176 = $[383];
  }
  let t177;
  if ($[384] === Symbol.for("react.memo_cache_sentinel")) {
    t177 = {
      regular: <Regular />
    };
    $[384] = t177;
  } else {
    t177 = $[384];
  }
  let t178;
  if ($[385] !== t) {
    t178 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.9.columns.1" components={t177} /></td>;
    $[385] = t;
    $[386] = t178;
  } else {
    t178 = $[386];
  }
  let t179;
  if ($[387] !== t) {
    t179 = t("seoOverdraft:sections.9.table.rows.9.columns.2");
    $[387] = t;
    $[388] = t179;
  } else {
    t179 = $[388];
  }
  let t180;
  if ($[389] !== t179) {
    t180 = <td className="w-30">{t179}</td>;
    $[389] = t179;
    $[390] = t180;
  } else {
    t180 = $[390];
  }
  let t181;
  if ($[391] !== t) {
    t181 = t("seoOverdraft:sections.9.table.rows.9.columns.3");
    $[391] = t;
    $[392] = t181;
  } else {
    t181 = $[392];
  }
  let t182;
  if ($[393] !== t181) {
    t182 = <td className="w-30">{t181}</td>;
    $[393] = t181;
    $[394] = t182;
  } else {
    t182 = $[394];
  }
  let t183;
  if ($[395] !== t) {
    t183 = t("seoOverdraft:sections.9.table.rows.9.columns.4");
    $[395] = t;
    $[396] = t183;
  } else {
    t183 = $[396];
  }
  let t184;
  if ($[397] !== t183) {
    t184 = <td className="w-30">{t183}</td>;
    $[397] = t183;
    $[398] = t184;
  } else {
    t184 = $[398];
  }
  let t185;
  if ($[399] !== t) {
    t185 = t("seoOverdraft:sections.9.table.rows.9.columns.5");
    $[399] = t;
    $[400] = t185;
  } else {
    t185 = $[400];
  }
  let t186;
  if ($[401] !== t185) {
    t186 = <td className="w-30">{t185}</td>;
    $[401] = t185;
    $[402] = t186;
  } else {
    t186 = $[402];
  }
  let t187;
  if ($[403] !== t) {
    t187 = t("seoOverdraft:sections.9.table.rows.9.columns.6");
    $[403] = t;
    $[404] = t187;
  } else {
    t187 = $[404];
  }
  let t188;
  if ($[405] !== t187) {
    t188 = <td className="w-30">{t187}</td>;
    $[405] = t187;
    $[406] = t188;
  } else {
    t188 = $[406];
  }
  let t189;
  if ($[407] !== t178 || $[408] !== t180 || $[409] !== t182 || $[410] !== t184 || $[411] !== t186 || $[412] !== t188) {
    t189 = <tr>{t178}{t180}{t182}{t184}{t186}{t188}</tr>;
    $[407] = t178;
    $[408] = t180;
    $[409] = t182;
    $[410] = t184;
    $[411] = t186;
    $[412] = t188;
    $[413] = t189;
  } else {
    t189 = $[413];
  }
  let t190;
  if ($[414] === Symbol.for("react.memo_cache_sentinel")) {
    t190 = {
      regular: <Regular />
    };
    $[414] = t190;
  } else {
    t190 = $[414];
  }
  let t191;
  if ($[415] !== t) {
    t191 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.10.columns.1" components={t190} /></td>;
    $[415] = t;
    $[416] = t191;
  } else {
    t191 = $[416];
  }
  let t192;
  if ($[417] !== t) {
    t192 = t("seoOverdraft:sections.9.table.rows.10.columns.2");
    $[417] = t;
    $[418] = t192;
  } else {
    t192 = $[418];
  }
  let t193;
  if ($[419] !== t192) {
    t193 = <td className="w-30">{t192}</td>;
    $[419] = t192;
    $[420] = t193;
  } else {
    t193 = $[420];
  }
  let t194;
  if ($[421] !== t) {
    t194 = t("seoOverdraft:sections.9.table.rows.10.columns.3");
    $[421] = t;
    $[422] = t194;
  } else {
    t194 = $[422];
  }
  let t195;
  if ($[423] !== t194) {
    t195 = <td className="w-30">{t194}</td>;
    $[423] = t194;
    $[424] = t195;
  } else {
    t195 = $[424];
  }
  let t196;
  if ($[425] !== t) {
    t196 = t("seoOverdraft:sections.9.table.rows.10.columns.4");
    $[425] = t;
    $[426] = t196;
  } else {
    t196 = $[426];
  }
  let t197;
  if ($[427] !== t196) {
    t197 = <td className="w-30">{t196}</td>;
    $[427] = t196;
    $[428] = t197;
  } else {
    t197 = $[428];
  }
  let t198;
  if ($[429] !== t) {
    t198 = t("seoOverdraft:sections.9.table.rows.10.columns.5");
    $[429] = t;
    $[430] = t198;
  } else {
    t198 = $[430];
  }
  let t199;
  if ($[431] !== t198) {
    t199 = <td className="w-30">{t198}</td>;
    $[431] = t198;
    $[432] = t199;
  } else {
    t199 = $[432];
  }
  let t200;
  if ($[433] !== t) {
    t200 = t("seoOverdraft:sections.9.table.rows.10.columns.6");
    $[433] = t;
    $[434] = t200;
  } else {
    t200 = $[434];
  }
  let t201;
  if ($[435] !== t200) {
    t201 = <td className="w-30">{t200}</td>;
    $[435] = t200;
    $[436] = t201;
  } else {
    t201 = $[436];
  }
  let t202;
  if ($[437] !== t191 || $[438] !== t193 || $[439] !== t195 || $[440] !== t197 || $[441] !== t199 || $[442] !== t201) {
    t202 = <tr>{t191}{t193}{t195}{t197}{t199}{t201}</tr>;
    $[437] = t191;
    $[438] = t193;
    $[439] = t195;
    $[440] = t197;
    $[441] = t199;
    $[442] = t201;
    $[443] = t202;
  } else {
    t202 = $[443];
  }
  let t203;
  if ($[444] === Symbol.for("react.memo_cache_sentinel")) {
    t203 = {
      regular: <Regular />
    };
    $[444] = t203;
  } else {
    t203 = $[444];
  }
  let t204;
  if ($[445] !== t) {
    t204 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.11.columns.1" components={t203} /></td>;
    $[445] = t;
    $[446] = t204;
  } else {
    t204 = $[446];
  }
  let t205;
  if ($[447] !== t) {
    t205 = t("seoOverdraft:sections.9.table.rows.11.columns.2");
    $[447] = t;
    $[448] = t205;
  } else {
    t205 = $[448];
  }
  let t206;
  if ($[449] !== t205) {
    t206 = <td className="w-30">{t205}</td>;
    $[449] = t205;
    $[450] = t206;
  } else {
    t206 = $[450];
  }
  let t207;
  if ($[451] !== t) {
    t207 = t("seoOverdraft:sections.9.table.rows.11.columns.3");
    $[451] = t;
    $[452] = t207;
  } else {
    t207 = $[452];
  }
  let t208;
  if ($[453] !== t207) {
    t208 = <td className="w-30">{t207}</td>;
    $[453] = t207;
    $[454] = t208;
  } else {
    t208 = $[454];
  }
  let t209;
  if ($[455] !== t) {
    t209 = t("seoOverdraft:sections.9.table.rows.11.columns.4");
    $[455] = t;
    $[456] = t209;
  } else {
    t209 = $[456];
  }
  let t210;
  if ($[457] !== t209) {
    t210 = <td className="w-30">{t209}</td>;
    $[457] = t209;
    $[458] = t210;
  } else {
    t210 = $[458];
  }
  let t211;
  if ($[459] !== t) {
    t211 = t("seoOverdraft:sections.9.table.rows.11.columns.5");
    $[459] = t;
    $[460] = t211;
  } else {
    t211 = $[460];
  }
  let t212;
  if ($[461] !== t211) {
    t212 = <td className="w-30">{t211}</td>;
    $[461] = t211;
    $[462] = t212;
  } else {
    t212 = $[462];
  }
  let t213;
  if ($[463] !== t) {
    t213 = t("seoOverdraft:sections.9.table.rows.11.columns.6");
    $[463] = t;
    $[464] = t213;
  } else {
    t213 = $[464];
  }
  let t214;
  if ($[465] !== t213) {
    t214 = <td className="w-30">{t213}</td>;
    $[465] = t213;
    $[466] = t214;
  } else {
    t214 = $[466];
  }
  let t215;
  if ($[467] !== t204 || $[468] !== t206 || $[469] !== t208 || $[470] !== t210 || $[471] !== t212 || $[472] !== t214) {
    t215 = <tr>{t204}{t206}{t208}{t210}{t212}{t214}</tr>;
    $[467] = t204;
    $[468] = t206;
    $[469] = t208;
    $[470] = t210;
    $[471] = t212;
    $[472] = t214;
    $[473] = t215;
  } else {
    t215 = $[473];
  }
  let t216;
  if ($[474] === Symbol.for("react.memo_cache_sentinel")) {
    t216 = {
      regular: <Regular />
    };
    $[474] = t216;
  } else {
    t216 = $[474];
  }
  let t217;
  if ($[475] !== t) {
    t217 = <td className="w-40"><Trans t={t} i18nKey="seoOverdraft:sections.9.table.rows.12.columns.1" components={t216} /></td>;
    $[475] = t;
    $[476] = t217;
  } else {
    t217 = $[476];
  }
  let t218;
  if ($[477] !== t) {
    t218 = t("seoOverdraft:sections.9.table.rows.12.columns.2");
    $[477] = t;
    $[478] = t218;
  } else {
    t218 = $[478];
  }
  let t219;
  if ($[479] !== t218) {
    t219 = <td className="w-30">{t218}</td>;
    $[479] = t218;
    $[480] = t219;
  } else {
    t219 = $[480];
  }
  let t220;
  if ($[481] !== t) {
    t220 = t("seoOverdraft:sections.9.table.rows.12.columns.3");
    $[481] = t;
    $[482] = t220;
  } else {
    t220 = $[482];
  }
  let t221;
  if ($[483] !== t220) {
    t221 = <td className="w-30">{t220}</td>;
    $[483] = t220;
    $[484] = t221;
  } else {
    t221 = $[484];
  }
  let t222;
  if ($[485] !== t) {
    t222 = t("seoOverdraft:sections.9.table.rows.12.columns.4");
    $[485] = t;
    $[486] = t222;
  } else {
    t222 = $[486];
  }
  let t223;
  if ($[487] !== t222) {
    t223 = <td className="w-30">{t222}</td>;
    $[487] = t222;
    $[488] = t223;
  } else {
    t223 = $[488];
  }
  let t224;
  if ($[489] !== t) {
    t224 = t("seoOverdraft:sections.9.table.rows.12.columns.5");
    $[489] = t;
    $[490] = t224;
  } else {
    t224 = $[490];
  }
  let t225;
  if ($[491] !== t224) {
    t225 = <td className="w-30">{t224}</td>;
    $[491] = t224;
    $[492] = t225;
  } else {
    t225 = $[492];
  }
  let t226;
  if ($[493] !== t) {
    t226 = t("seoOverdraft:sections.9.table.rows.12.columns.6");
    $[493] = t;
    $[494] = t226;
  } else {
    t226 = $[494];
  }
  let t227;
  if ($[495] !== t226) {
    t227 = <td className="w-30">{t226}</td>;
    $[495] = t226;
    $[496] = t227;
  } else {
    t227 = $[496];
  }
  let t228;
  if ($[497] !== t217 || $[498] !== t219 || $[499] !== t221 || $[500] !== t223 || $[501] !== t225 || $[502] !== t227) {
    t228 = <tr>{t217}{t219}{t221}{t223}{t225}{t227}</tr>;
    $[497] = t217;
    $[498] = t219;
    $[499] = t221;
    $[500] = t223;
    $[501] = t225;
    $[502] = t227;
    $[503] = t228;
  } else {
    t228 = $[503];
  }
  let t229;
  if ($[504] !== t111 || $[505] !== t124 || $[506] !== t137 || $[507] !== t150 || $[508] !== t163 || $[509] !== t176 || $[510] !== t189 || $[511] !== t202 || $[512] !== t215 || $[513] !== t228 || $[514] !== t85 || $[515] !== t98) {
    t229 = <>{t85}{t98}{t111}{t124}{t137}{t150}{t163}{t176}{t189}{t202}{t215}{t228}</>;
    $[504] = t111;
    $[505] = t124;
    $[506] = t137;
    $[507] = t150;
    $[508] = t163;
    $[509] = t176;
    $[510] = t189;
    $[511] = t202;
    $[512] = t215;
    $[513] = t228;
    $[514] = t85;
    $[515] = t98;
    $[516] = t229;
  } else {
    t229 = $[516];
  }
  let t230;
  if ($[517] === Symbol.for("react.memo_cache_sentinel")) {
    t230 = [...Array(2)];
    $[517] = t230;
  } else {
    t230 = $[517];
  }
  let t231;
  if ($[518] !== t) {
    t231 = t230.map((__1, i_0) => {
      const notesIndex = i_0 + 1 as NumericRange<1, 2>;
      return <Trans key={i_0} t={t} i18nKey={`seoOverdraft:sections.9.notes.${notesIndex}`} />;
    });
    $[518] = t;
    $[519] = t231;
  } else {
    t231 = $[519];
  }
  let t232;
  if ($[520] !== t229 || $[521] !== t231 || $[522] !== t72) {
    t232 = <Table head={t72} body={t229} notes={t231} className="mt-8" />;
    $[520] = t229;
    $[521] = t231;
    $[522] = t72;
    $[523] = t232;
  } else {
    t232 = $[523];
  }
  let t233;
  if ($[524] === Symbol.for("react.memo_cache_sentinel")) {
    t233 = [...Array(12)];
    $[524] = t233;
  } else {
    t233 = $[524];
  }
  let t234;
  if ($[525] !== t) {
    t234 = t233.map((__2, i_1) => {
      const transIndex_0 = i_1 + 1 as NumericRange<1, 12>;
      return <Trans key={i_1} t={t} i18nKey={`seoOverdraft:sections.9.subsections.${transIndex_0}`} components={{
        subheader: <SubHeader />,
        paragraph: <Paragraph />,
        semibold: <SemiBold />
      }} />;
    });
    $[525] = t;
    $[526] = t234;
  } else {
    t234 = $[526];
  }
  let t235;
  if ($[527] !== t232 || $[528] !== t234 || $[529] !== t59) {
    t235 = <>{t59}{t232}{t234}</>;
    $[527] = t232;
    $[528] = t234;
    $[529] = t59;
    $[530] = t235;
  } else {
    t235 = $[530];
  }
  let t236;
  if ($[531] !== t235 || $[532] !== t57) {
    t236 = {
      title: t57,
      content: t235
    };
    $[531] = t235;
    $[532] = t57;
    $[533] = t236;
  } else {
    t236 = $[533];
  }
  let t237;
  if ($[534] !== t) {
    t237 = t("seoOverdraft:sections.10.title");
    $[534] = t;
    $[535] = t237;
  } else {
    t237 = $[535];
  }
  let t238;
  if ($[536] === Symbol.for("react.memo_cache_sentinel")) {
    t238 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[536] = t238;
  } else {
    t238 = $[536];
  }
  let t239;
  if ($[537] !== t) {
    t239 = <Trans t={t} i18nKey="seoOverdraft:sections.10.content" components={t238} />;
    $[537] = t;
    $[538] = t239;
  } else {
    t239 = $[538];
  }
  let t240;
  if ($[539] !== t) {
    t240 = t("seoOverdraft:sections.10.title");
    $[539] = t;
    $[540] = t240;
  } else {
    t240 = $[540];
  }
  let t241;
  if ($[541] !== t240) {
    t241 = <Image src="/images/sections/seoOverdraft/cs/2.png" width={768} height={500} alt={t240} isRounded={true} />;
    $[541] = t240;
    $[542] = t241;
  } else {
    t241 = $[542];
  }
  let t242;
  if ($[543] !== t239 || $[544] !== t241) {
    t242 = <>{t239}{t241}</>;
    $[543] = t239;
    $[544] = t241;
    $[545] = t242;
  } else {
    t242 = $[545];
  }
  let t243;
  if ($[546] !== t237 || $[547] !== t242) {
    t243 = {
      title: t237,
      content: t242
    };
    $[546] = t237;
    $[547] = t242;
    $[548] = t243;
  } else {
    t243 = $[548];
  }
  let t244;
  if ($[549] !== t) {
    t244 = t("seoOverdraft:sections.11.title");
    $[549] = t;
    $[550] = t244;
  } else {
    t244 = $[550];
  }
  let t245;
  if ($[551] === Symbol.for("react.memo_cache_sentinel")) {
    t245 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[551] = t245;
  } else {
    t245 = $[551];
  }
  let t246;
  if ($[552] !== t) {
    t246 = <Trans t={t} i18nKey="seoOverdraft:sections.11.content" components={t245} />;
    $[552] = t;
    $[553] = t246;
  } else {
    t246 = $[553];
  }
  let t247;
  if ($[554] !== t244 || $[555] !== t246) {
    t247 = {
      title: t244,
      content: t246
    };
    $[554] = t244;
    $[555] = t246;
    $[556] = t247;
  } else {
    t247 = $[556];
  }
  let t248;
  if ($[557] !== t) {
    t248 = t("seoOverdraft:sections.12.title");
    $[557] = t;
    $[558] = t248;
  } else {
    t248 = $[558];
  }
  let t249;
  let t250;
  if ($[559] === Symbol.for("react.memo_cache_sentinel")) {
    t249 = <Paragraph />;
    t250 = <SemiBold />;
    $[559] = t249;
    $[560] = t250;
  } else {
    t249 = $[559];
    t250 = $[560];
  }
  let t251;
  if ($[561] === Symbol.for("react.memo_cache_sentinel")) {
    t251 = {
      paragraph: t249,
      semibold: t250,
      link1: <Link analyticsParam="linkToDeferredPayment" testId="linkToDeferredPayment" to={LINKS().deferredPayment} />
    };
    $[561] = t251;
  } else {
    t251 = $[561];
  }
  let t252;
  if ($[562] !== t) {
    t252 = <Trans t={t} i18nKey="seoOverdraft:sections.12.content" components={t251} />;
    $[562] = t;
    $[563] = t252;
  } else {
    t252 = $[563];
  }
  let t253;
  if ($[564] !== t248 || $[565] !== t252) {
    t253 = {
      title: t248,
      content: t252
    };
    $[564] = t248;
    $[565] = t252;
    $[566] = t253;
  } else {
    t253 = $[566];
  }
  let t254;
  if ($[567] !== t) {
    t254 = t("core:faqs.title");
    $[567] = t;
    $[568] = t254;
  } else {
    t254 = $[568];
  }
  let t255;
  if ($[569] !== faqsData) {
    t255 = <FAQs data={faqsData} />;
    $[569] = faqsData;
    $[570] = t255;
  } else {
    t255 = $[570];
  }
  let t256;
  if ($[571] !== t254 || $[572] !== t255) {
    t256 = {
      title: t254,
      content: t255
    };
    $[571] = t254;
    $[572] = t255;
    $[573] = t256;
  } else {
    t256 = $[573];
  }
  let t257;
  if ($[574] !== t18 || $[575] !== t236 || $[576] !== t243 || $[577] !== t247 || $[578] !== t25 || $[579] !== t253 || $[580] !== t256 || $[581] !== t29 || $[582] !== t33 || $[583] !== t37 || $[584] !== t41 || $[585] !== t45 || $[586] !== t56) {
    t257 = [t18, t25, t29, t33, t37, t41, t45, t56, t236, t243, t247, t253, t256];
    $[574] = t18;
    $[575] = t236;
    $[576] = t243;
    $[577] = t247;
    $[578] = t25;
    $[579] = t253;
    $[580] = t256;
    $[581] = t29;
    $[582] = t33;
    $[583] = t37;
    $[584] = t41;
    $[585] = t45;
    $[586] = t56;
    $[587] = t257;
  } else {
    t257 = $[587];
  }
  let t258;
  if ($[588] !== menuPromoBanners || $[589] !== t12 || $[590] !== t257 || $[591] !== t5 || $[592] !== t7 || $[593] !== t9) {
    t258 = <SeoPageLayout menuPromoBanners={menuPromoBanners} seo={t5} title={t7} intro={t9} introButton={t12} sections={t257} />;
    $[588] = menuPromoBanners;
    $[589] = t12;
    $[590] = t257;
    $[591] = t5;
    $[592] = t7;
    $[593] = t9;
    $[594] = t258;
  } else {
    t258 = $[594];
  }
  return t258;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('kontokorent');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'seoOverdraft']))
    }
  };
};